import React from 'react';
import Logo from '../../../../assets/svg/Logo';
import style from './WagWelcomeHeader.module.css';

export const WagWelcomeHeader = () => (
  <div
    className={`container-fluid p-0 ${style.header}`}
    data-testid="welcome-header-background"
  >
    <div className={style.logoContainer}>
      <Logo className={style.logo} />
    </div>
  </div>
);
